import { render, staticRenderFns } from "./DataGrowthChart.vue?vue&type=template&id=47266163&"
import script from "./DataGrowthChart.vue?vue&type=script&lang=js&"
export * from "./DataGrowthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports